import { render, staticRenderFns } from "./SpecRole.vue?vue&type=template&id=5bc396fc&scoped=true&lang=pug"
import script from "./SpecRole.vue?vue&type=script&lang=js"
export * from "./SpecRole.vue?vue&type=script&lang=js"
import style0 from "./SpecRole.vue?vue&type=style&index=0&id=5bc396fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc396fc",
  null
  
)

export default component.exports